import React from "react";
import Meta from "../components/Meta";

const AboutUsPage = () => {
  return (
    <>
     <Meta title="Welcome To E-Blog" />
      <div className="alert alert-info p-5">
        <div className="d-flex justify-content-center p-5">
          <h1>About us</h1>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <h4>Our story</h4>
      </div>
      <hr />
      <div className="d-flex justify-content-center">
        <p className="text-justify">
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Deserunt
          doloremque nesciunt dolorem numquam maxime quisquam magnam. Modi
          voluptate repellendus magnam voluptates adipisci deserunt ullam
          similique fugiat sequi, laborum repudiandae praesentium corporis
          delectus expedita placeat officiis facilis at quo! Corporis, tempore
          fuga voluptatem cupiditate dolores eaque libero vero beatae
          necessitatibus laborum autem quaerat debitis provident illum delectus
          a iure repellat, deserunt illo sit vel? Tempora provident error
          eligendi cupiditate quos quasi dolorum nostrum quia rem, eum iste
          eveniet perspiciatis tempore id vero sunt ea fugiat, voluptatibus unde
          laborum ut. Unde pariatur, repudiandae in quaerat reprehenderit
          aperiam vitae quidem itaque. Ut eligendi placeat voluptates,
          consequuntur adipisci eaque suscipit porro corrupti quia officia
          molestias ipsa, quisquam reprehenderit nemo, harum recusandae
          reiciendis deleniti esse voluptate. Odio, voluptatem asperiores.
          Consectetur maxime in hic deleniti reiciendis dolore cumque expedita
          nostrum quidem impedit ad iusto aliquam nisi ab officia exercitationem
          vitae fuga eaque, dicta vero? Eaque ducimus labore doloribus debitis
          aspernatur iste minima officiis ipsa nam unde accusamus culpa ratione
          laborum, nihil optio repellat, natus nesciunt in explicabo. Id atque
          dolore est? Error libero aperiam, sed quidem tempora at, cum officia,
          consequuntur tenetur nam voluptatem fugit ex laudantium quae dolorem
          placeat officiis sint! Soluta, doloremque mollitia eveniet obcaecati
          nemo omnis asperiores saepe modi laborum! Voluptate sapiente eius non
          at voluptatum voluptatem fugiat dolorum quia consequatur doloremque ad
          nam eveniet natus eligendi neque voluptates, laboriosam ea molestias
          facilis velit odio nisi nemo. Quia nulla, itaque exercitationem esse
          aspernatur eos quod, dolorem soluta eaque magnam eveniet, at ducimus
          iusto.
        </p>
      </div>
    </>
  );
};

export default AboutUsPage;
